import CarouselModal from "./CarouselModel";
import { useState } from "react";

const Carousel = ({ wheel, check_last_spin }) => {
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => {
    setShowModal((perv) => !perv);
  };
  return (
    <div className={`${"carouselHome"}`}>
      <CarouselModal
        check_last_spin={check_last_spin}
        showModal={showModal}
        wheelItems={wheel}
        handleShowModal={handleShowModal}
      />
      <img
        className={`carouselImg`}
        src="public/assets/home-wheel.svg"
        alt="carousel"
      />
      <div className={"carouselText"}>
        <span>گردونه شانس روزانه</span>
        <button onClick={handleShowModal}>شانس خودتو امتحان کن</button>
      </div>
    </div>
  );
};

export default Carousel;
